export default __webpack_public_path__ + "static/pattern-350118bfdb850f1de00e73f34219ea00.mp4";